// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root___Bv0h","label":"LabeledBox_label__3upry"};